import { useContext } from 'react';
import { ConversionHelpContext } from '@bingads-webui-campaign-react/conversion-help';

export const platforms = {
  WordPress: 'WordPress',
  Wix: 'Wix',
  Shopify: 'Shopify',
  BigCommerce: 'BigCommerce',
  WooCommerce: 'WooCommerce',
};

export const getPlatforms = (isSmartOrExpertMode) => {
  const filteredPlatforms = { ...platforms, SquareSpace: 'SquareSpace' };
  if (!isSmartOrExpertMode) {
    delete filteredPlatforms.SquareSpace;
  }
  return filteredPlatforms;
};

export function useHelpIds() {
  const helpIds = useContext(ConversionHelpContext);

  return {
    ...helpIds.emailPlatform,
    allPlatformsLearnMore: helpIds.allPlatformsLearnMore,
  };
}
